import { useLocation } from "react-router-dom";
import Page from "src/components/Report/Page";

export default function Page7t() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobId = params.get("id");

    let nezamhayeKeifiat;
    if (JSON.parse(localStorage?.data)?.[jobId]?.nezamhayeKeifiat) {
        nezamhayeKeifiat = JSON.parse(localStorage?.data)?.[jobId]?.nezamhayeKeifiat
    } else {
        nezamhayeKeifiat = [];
    }


    let ghavaninVaMoghararat;
    if (JSON.parse(localStorage?.data)?.[jobId]?.ghavaninVaMoghararat) {
        ghavaninVaMoghararat = JSON.parse(localStorage?.data)?.[jobId]?.ghavaninVaMoghararat
    } else {
        ghavaninVaMoghararat = [];
    }
    return (
        <Page pageNumber={11}>
            <div className="font-bold text-lg">
                اهم استانداردها و نظام‌های کیفیت مورد نیاز:
            </div>
            <p className="text-black text-justify">
                این بخش به مجموعه استانداردها، چارچوب‌ها و نظام‌های کیفیتی اشاره دارد که رعایت آن‌ها برای انجام صحیح و قابل اعتماد وظایف شغلی ضروری است. استانداردهایی مانند ISO، EFQM، OHSAS و سایر نظام‌های مدیریتی و ایمنی، مبنای ارزیابی کیفیت عملکرد و فرآیندهای کاری هستند. آشنایی یا تسلط بر این نظام‌ها موجب ارتقاء بهره‌وری، انطباق با الزامات قانونی و بهبود مستمر می‌شود. درج این بخش به طراحی برنامه‌های آموزشی و کنترل کیفیت سازمانی کمک می‌نماید.
            </p>
            <div className="relative">
                <div className="flex flex-col w-full pl-4">
                    <div className="w-full h-[80px] bg-green-300 text-black flex items-center p-4">تسلط</div>
                    <div className="w-full h-[80px] bg-green-200 text-black flex items-center p-4">توانایی</div>
                    <div className="w-full h-[80px] bg-green-100 text-black flex items-center p-4">آشنایی</div>
                </div>
                <div className="flex flex-col">
                    <div className="absolute top-[30px] left-0">- 3</div>
                    <div className="absolute top-[110px] left-0">- 2</div>
                    <div className="absolute top-[190px] left-[4px]">- 1</div>
                    <div className="w-full pl-4">
                        <div className="w-full h-[2px] bg-gray-400"></div>
                    </div>
                    <div className="h-[240px] w-[2px] bg-gray-400 absolute left-[15px] top-0"></div>
                </div>
                <div className="flex gap-[0px] absolute -bottom-[0px] left-[25px]">
                    {
                        Object.keys(nezamhayeKeifiat).map((key, index) => {

                            if (nezamhayeKeifiat[key].value >= 3) {
                                let height = 0;
                                nezamhayeKeifiat[key].value == 3 ? height = 40 : nezamhayeKeifiat[key].value == 4 ? height = 120 : height = 200

                                return (
                                    <div className="flex relative flex-col gap-1 items-center justify-end w-[40px]">
                                        <div
                                            className="w-[20px] bg-green-700 rounded-t relative"
                                            style={{ height: `${height}px` }}
                                        >

                                            <div
                                                className="w-[40px] text-[10px] -rotate-90 right-4 text-white absolute top-1"
                                                style={{ whiteSpace: "nowrap", transformOrigin: "100% 0%" }}
                                            >
                                                {height > 40 ? key : key.substring(0, 5) + "..."}
                                            </div>

                                        </div>
                                    </div>
                                )
                            }
                        })
                    }
                </div>

            </div>
            <div className="font-bold text-lg mt-10">
                استانداردها و نظام‌های کیفیت مورد نیاز:
            </div>
            <div className="flex flex-wrap gap-2">
                {Object.keys(nezamhayeKeifiat).map((key, index) => {
                    if (nezamhayeKeifiat[key].value >= 2) {

                        return (<span className="odd-color bg-gray-300 rounded p-2 text-xs" key={index}>{key}</span>)
                    }
                })}
            </div>
            <div className="font-bold text-lg mt-5">
                اهم قوانین و مقررات مورد نیاز:
            </div>
            <p className="text-black text-justify">
                این بخش به مجموعه قوانین، آیین‌نامه‌ها و سیاست‌های حاکمیتی اشاره دارد که رعایت آن‌ها برای انجام وظایف شغلی الزامی است. قوانین کار، مالیات، بیمه، تجارت، حقوق مدنی و مقررات اداری از جمله موارد کلیدی هستند. آشنایی یا تسلط بر این مقررات، مبنای تصمیم‌گیری صحیح، انطباق حقوقی و عملکرد مسئولانه فرد در سازمان است. درج این بخش به طراحی آموزش‌های حقوقی و تضمین انضباط سازمانی کمک می‌کند.
            </p>
            <div className="relative">
                <div className="flex flex-col w-full pl-4">
                    <div className="w-full h-[80px] bg-orange-300 text-black flex items-center p-4">تسلط</div>
                    <div className="w-full h-[80px] bg-orange-200 text-black flex items-center p-4">توانایی</div>
                    <div className="w-full h-[80px] bg-orange-100 text-black flex items-center p-4">آشنایی</div>
                </div>
                <div className="flex flex-col">
                    <div className="absolute top-[30px] left-0">- 3</div>
                    <div className="absolute top-[110px] left-0">- 2</div>
                    <div className="absolute top-[190px] left-[4px]">- 1</div>
                    <div className="w-full pl-4">
                        <div className="w-full h-[2px] bg-gray-400"></div>
                    </div>
                    <div className="h-[240px] w-[2px] bg-gray-400 absolute left-[15px] top-0"></div>
                </div>
                <div className="flex gap-[0px] absolute -bottom-[0px] left-[25px]">
                    {
                        Object.keys(ghavaninVaMoghararat).map((key, index) => {

                            if (ghavaninVaMoghararat[key].value >= 3) {
                                let height = 0;
                                ghavaninVaMoghararat[key].value == 3 ? height = 40 :
                                    ghavaninVaMoghararat[key].value == 4 ? height = 120 : height = 200

                                return (
                                    <div className="flex relative flex-col gap-1 items-center justify-end w-[40px]">

                                        <div
                                            className="w-[20px] bg-orange-700 rounded-t relative"
                                            style={{ height: `${height}px` }}
                                        >
                                            <div
                                                className="w-[40px] text-[10px] -rotate-90 right-4 text-white absolute top-1"
                                                style={{ whiteSpace: "nowrap", transformOrigin: "100% 0%" }}
                                            >
                                                {height > 40 ? key : key.substring(0, 5) + "..."}
                                            </div>
                                        </div>

                                    </div>
                                )
                            }
                        })
                    }
                </div>

            </div>
            <div className="font-bold text-lg mt-10">
                قوانین و مقررات مورد نیاز:
            </div>
            <div className="flex flex-wrap gap-2">
                {Object.keys(ghavaninVaMoghararat).map((key, index) => {
                    if (ghavaninVaMoghararat[key].value >= 2) {

                        return (<span className="odd-color bg-gray-300 rounded p-2 text-xs" key={index}>{key}</span>)
                    }
                })}
            </div>
        </Page>
    )
}